(ns ycweb.app.admin.wholesale.clientorders.clientorder.tabs.invoice
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.common :as co.cmn]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.config.invoice :as i.cfg]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.headings :as headings]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.core :as yuc]
   [ycweb.util.comms :as comms]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc invoice-summary < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        invoice-items-idx (cmn/curact action-atom :client-order/invoice.item-list)

        summary-input-data
        (map
          (fn [[_ coi]]
            {:variation/features (:variation/features coi)
             :line-item/qty (:invoice-line/qty coi)
             :line-item/price (:invoice-line/price coi)
             :line-item/discount (:invoice-line/discount coi)
             :line-item/calc-vat (:invoice-line/tax coi)})
          invoice-items-idx)]

    [:div
     (co.cmn/display-total-summary (co.cmn/summary-calculations summary-input-data))]))

(rum/defc payment-summary < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        invoice-items-idx (cmn/curact action-atom :client-order/invoice.item-list)
        payment-items-idx (cmn/curact action-atom :client-order/payment.item-list)
        credit-note-allocations (cmn/curact action-atom :client-order/credit-note-allocations)

        payment-amounts
        (map
          (fn [[_ payment-item]]
            (trf/fromcurrency
              (:payment-line/amount payment-item)))
          payment-items-idx)

        cn-allocation-amounts
        (map
          (fn [credit-note-allocation]
            (trf/fromcurrency
              (:credit-note-allocation/amount credit-note-allocation)))
          credit-note-allocations)

        total-payment-amount (reduce + 0 payment-amounts)
        total-credit-note-allocation-amount (reduce + 0 cn-allocation-amounts)
        total-paid (+ total-payment-amount total-credit-note-allocation-amount)

        summary-input-data
        (map
          (fn [[_ coi]]
            {:variation/features (:variation/features coi)
             :line-item/qty (:invoice-line/qty coi)
             :line-item/price (:invoice-line/price coi)
             :line-item/discount (:invoice-line/discount coi)
             :line-item/calc-vat (:invoice-line/tax coi)})
          invoice-items-idx)

        {:keys [total-inc-vat]} (co.cmn/summary-calculations summary-input-data)

        outstanding-amount (- total-inc-vat total-paid)]

    [:div.u-margin-top-40
     [:div
      {:class (yuc/bem :flex-grid-group [:flush-force :align-right])}
      [:div
       {:class (yuc/bem :flex-grid-block [:m-1-4])}
       [:div.flex-grid-content
        [:span
         [:b "Total Paid (ZAR): "]
         (yuc/number-format total-payment-amount 2)]]]]

     [:div
      {:class (yuc/bem :flex-grid-group [:flush-force :align-right])}
      [:div
       {:class (yuc/bem :flex-grid-block [:m-1-4])}
       [:div.flex-grid-content
        [:span
         [:b "Allocated Credit (ZAR): "]
         (yuc/number-format total-credit-note-allocation-amount 2)]]]]

     [:div
      {:class (yuc/bem :flex-grid-group [:flush-force :align-right])}
      [:div
       {:class (yuc/bem :flex-grid-block [:m-1-4])}
       [:div.flex-grid-content
        [:span
         [:b "Balance Due (ZAR): "]
         (yuc/number-format outstanding-amount 2)]]]]]))

(rum/defc email-invoice-modal-body < rum/reactive [app-atom config-atom]
  (let [config (rum/react config-atom)]
    [:div
     [:h3
      {:class (yuc/bem :heading [:medium-large])}
      (:title config)]
     (when (yuc/presence (:options config))
       [:div.checkbox-wrapper
        (map
          (fn [option]
            [:div.checkbox-item.u-margin-bottom-10
             (forms/checkbox
               (:label option)
               (rum/cursor-in config-atom [(:input-key config) (:value option)])
               {})])
          (:options config))])]))

(rum/defc email-invoice-modal-footer < rum/reactive [app-atom config-atom]
  (let [config (rum/react config-atom)]
    (grid/button-row
      {:left-text (or (:cancel-text config) "Cancel")
       :left-no-icon true
       :left-fn
       #(grid/dispatch-modal-action app-atom (or (:cancel-key config) :grid/single-input-modal-cancel))
       :right-text (or (:save-text config) "Submit")
       :right-no-icon true
       :right-fn
       #(grid/dispatch-modal-action app-atom (or (:save-key config) :grid/single-input-modal-save))})))

(defmethod grid/modal-config :admin.wholesale/client-order.email-modal [_ _ _]
  {:body email-invoice-modal-body
   :footer email-invoice-modal-footer
   :modal-type :alert})

(rum/defc display-invoice < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        order-status (:client-order/status client-order)
        override-invoice (cmn/curact action-atom :override-invoice)
        invoice (cmn/curact process-atom :invoice)
        invoice-status (:invoice/status invoice)
        invoice-line-items (cmn/curact action-atom :client-order/invoice.item-list)
        customer-contacts (cmn/curact process-atom :customer-contacts)
        disabled?
        (and
          (or
            (not (contains? #{"Sent to Courier" "Delivered"} order-status))
            (not (= invoice-status "Draft")))
          (not override-invoice))]

    [:<>
     [:div
      [:div
       [:div.u-margin-bottom-30
        {:class (yuc/bem :flex-grid-group [:flush :align-left :valign-middle])}
        [:div
         {:class (yuc/bem :flex-grid-block [:fluid :flush :grow-yes])}
         [:div.flex-grid-content
          (headings/heading (str "Invoice" (when invoice (str " " (:invoice/invoice-number invoice)))) {:type :h2 :flush true})]]

        [:div
         {:class (yuc/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (cond
            (not (= invoice-status "Draft"))
            [:div
             {:class (yuc/bem :flex-grid-block [:fluid])}
             (buttons/button-web "Override invoice"
               (if override-invoice
                 (merge
                   (urlstate/href-on-click
                     #(do
                        (toaster/open-toast app-atom :warning "Disabling override" {:closetime 4000})
                        (swap! action-atom assoc :override-invoice false)))
                   {:style :negative
                    :size :small
                    :icon :wrench})
                 (merge
                   (urlstate/href-on-click
                     #(grid/single-input-modal app-atom
                        {:title "Override invoice"
                         :text "This action will allow you to edit the details of the invoice"
                         :cancel-text "Cancel"
                         :save-key :admin.wholesale/client-order.invoice.override
                         :input-key :override-reason
                         :field-text "Reason"
                         :auto-focus true}))
                   {:style :negative
                    :size :small
                    :icon :wrench})))]

            :else
            [:div
             {:class (yuc/bem :flex-grid-block [:fluid])}
             (buttons/button-web "Authorise"
               (merge
                 (urlstate/href-on-click
                   #(grid/dispatch-action app-atom
                      :admin.wholesale/client-order.invoice.authorise {}))
                 {:style :secondary
                  :size :small
                  :disabled disabled?}))])]]

        [:div
         {:class (yuc/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (buttons/button-web "Email Invoice"
            (merge
              (urlstate/href-on-click
                #(grid/open-modal app-atom :admin.wholesale/client-order.email-modal
                   {:title "Email Invoice"
                    :text "This action will email the invoice to the customer."
                    :cancel-text "Cancel"
                    :input-key :emails
                    :field-text "Emails"
                    :auto-focus true
                    :save-text "Email"
                    :save-key :admin.wholesale/client-order.invoice.email
                    :options
                    (distinct
                      (map
                        (fn [contact]
                          {:value (:email contact) :label (:email contact)})
                        customer-contacts))}))
              {:style :secondary
               :size :small
               :icon :email}))]]

        [:div
         {:class (yuc/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          [:form
           {:method "GET" :target "_blank"
            :action (str "/api/pdf/client-order/" (:client-order/uuid client-order)  "/invoice/" (:invoice/uuid invoice "not-found"))}
           (buttons/button-web "Download invoice"
             {:style :secondary
              :size :small
              :icon :download})]]]]

       [:div
        [:div
         {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}
         [:div
          {:class (yuc/bem :flex-grid-block [:fluid])}
          [:div.flex-grid-content
           [:div
            (forms/field-label "Invoice date:" {})
            (datepicker/raw-datepicker app-atom "dd/mm/yyyy"
              [:admin.wholesale :invoice :invoice/invoice-date]
              {:datatype :date/dmy
               :size :small
               :disabled disabled?})]]]
         [:div
          {:class (yuc/bem :flex-grid-block [:fluid])}
          [:div.flex-grid-content
           [:div
            (forms/field-label "Due date:" {})
            (datepicker/raw-datepicker app-atom "dd/mm/yyyy"
              [:admin.wholesale :invoice :invoice/invoice-due-date]
              {:datatype :date/dmy
               :size :small
               :disabled true})]]]

         [:div
          {:class (yuc/bem :flex-grid-block [:fluid :valign-middle :align-right])}
          [:div.flex-grid-content
           (buttons/button-web (str (if (not-empty invoice-line-items) "Regenerate" "Generate") " invoice")
             (merge
               (urlstate/href-on-click
                 #(grid/dispatch-action app-atom
                    :admin.wholesale/client-order.invoice.manage {:action :create}))
               {:style :primary
                :size :small
                :disabled disabled?
                :class "u-min-width-128"}))]]

         [:div
          {:class (yuc/bem :flex-grid-block [:fluid :valign-middle])}
          [:div.flex-grid-content
           (buttons/button-web "Update invoice"
             (merge
               (urlstate/href-on-click
                 #(grid/dispatch-action app-atom
                    :admin.wholesale/client-order.invoice.manage {:action :update}))
               {:style :primary
                :size :small
                :disabled disabled?
                :class "u-min-width-128"}))]]]]

       [:div
        [:div
         [:div
          (datatables/table app-atom i.cfg/datatable-invoices-key i.cfg/invoice-table-fns)]
         [:div
          (headings/heading "Additional Charges and Services" {:type :h3 :size :small})
          (datatables/table app-atom i.cfg/datatable-additional-key i.cfg/additional-charges-table-fns)]
         (invoice-summary app-atom)]
        [:div
         [:div
          (headings/heading "Payments" {:type :h3 :size :small :flush true})
          (datatables/table app-atom i.cfg/datatable-payments-key i.cfg/datatable-payment-fns)]]]
       (payment-summary app-atom)]]
     (toaster/loading-overlay app-atom :admin.wholesale/client-order.invoice)]))

(defmethod grid/action :admin.wholesale/client-order.invoice.authorise [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        invoice (cmn/curact process-atom :invoice)
        dear-sync (cmn/curact process-atom :dear-sync/method)]

    (cond
      (= dear-sync :pull)
      (grid/open-modal app-atom :grid/message
        {:title "Warning"
         :text
         (feedback/feedback :warning
           [:b "The system is set to sync from Dear"]
           [:div
            [:p "The system is set to pull from Dear, Authorisation has been disabled."]])})

      :else
      (grid/open-modal app-atom :grid/confirm
        {:title "Authorise Invoice"
         :text
         [:p
          "This will authorise the invoice and will be irreversible.
           Make sure the dates supplied are correct."]
         :cancel-text "Cancel"
         :confirm-fn
         (fn [app-atom]
           (toaster/open-overlay app-atom :admin.wholesale/client-order.invoice.authorise "Authorising invoice.")
           (comms/send :admin.wholesale/client-order.invoice.authorise
             {:invoice-id (:invoice/id invoice)
              :client-order-uuid (:client-order/uuid client-order)}))}))))

(defmethod comms/receive :admin.wholesale/client-order.invoice.authorise [app-atom {:keys [invoice finance-status msg]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (toaster/close-overlay app-atom :admin.wholesale/client-order.invoice.authorise)
    (swap! process-atom update :invoice assoc :invoice/status (:invoice/status invoice))
    (swap! process-atom update :wholesale-statuses assoc :finance-status finance-status)
    (toaster/open-toast app-atom :success msg {:closetime 3000})))

(defmethod grid/action :admin.wholesale/client-order.invoice.manage [app-atom config _]
  (let [action (:action config)
        action-atom (cmn/action-cursor app-atom)
        process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        override-invoice (cmn/curact action-atom :override-invoice)
        invoice (cmn/curact process-atom :invoice)
        invoice-date (:invoice/invoice-date invoice)
        invoice-due-date (:invoice/invoice-due-date invoice)]

    (case action
      :create
      (do
        (toaster/open-overlay app-atom :admin.wholesale/client-order.invoice "Generating invoice.")
        (comms/send :admin.wholesale/client-order.invoice.generate
          {:invoice-id (:invoice/id invoice)
           :client-order-uuid (:client-order/uuid client-order)
           :override-invoice override-invoice}))

      :update
      (do
        (toaster/open-overlay app-atom :admin.wholesale/client-order.invoice "Updating invoice.")
        (comms/send :admin.wholesale/client-order.invoice.update
          {:invoice-id (:invoice/id invoice)
           :client-order-uuid (:client-order/uuid client-order)
           :invoice-date invoice-date
           :invoice-due-date invoice-due-date})))))

(defmethod comms/receive :admin.wholesale/client-order.invoice.generate [app-atom {:keys [msg invoice]}]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order-uuid (cmn/curact process-atom [:client-order :client-order/uuid])
        invoice-atom (rum/cursor process-atom :invoice)
        invoice-date (:invoice/invoice-date invoice)
        invoice-due-date (:invoice/invoice-due-date invoice)]
    (toaster/close-overlay app-atom :admin.wholesale/client-order.invoice)
    (toaster/open-toast app-atom :success msg {:closetime 3000})

    (swap! invoice-atom merge
      {:invoice/invoice-date invoice-date
       :invoice/invoice-due-date invoice-due-date})

    (datatables/overlay app-atom :open i.cfg/datatable-invoices-key)
    (datatables/overlay app-atom :open i.cfg/datatable-additional-key)
    (comms/send :admin.wholesale/client-order.invoice.item-list
      {:client-order/uuid client-order-uuid})))

(defmethod comms/receive :admin.wholesale/client-order.invoice.update [app-atom {:keys [msg invoice]}]
  (let [process-atom (cmn/process-cursor app-atom)
        invoice-atom (rum/cursor process-atom :invoice)
        invoice-date (:invoice/invoice-date invoice)
        invoice-due-date (:invoice/invoice-due-date invoice)]
    (toaster/open-overlay app-atom :admin.wholesale/client-order.invoice)
    (toaster/open-toast app-atom :success msg {:closetime 3000})
    (swap! invoice-atom merge
      {:invoice/invoice-date invoice-date
       :invoice/invoice-due-date invoice-due-date})))

(defmethod grid/action :admin.wholesale/client-order.invoice.item-list [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        client-order-uuid (cmn/curact process-atom [:client-order :client-order/uuid])
        invoice-line-items (cmn/curact action-atom :client-order/invoice.item-list)]

    (datatables/initiate app-atom (i.cfg/invoice-table-config app-atom) i.cfg/invoice-table-fns)
    (datatables/initiate app-atom (i.cfg/additional-charges-table-config app-atom) i.cfg/additional-charges-table-fns)
    (datatables/initiate app-atom (i.cfg/datatable-payments-config app-atom) i.cfg/datatable-payment-fns)

    (when (or (nil? invoice-line-items) (empty? invoice-line-items))
      (datatables/overlay app-atom :open i.cfg/datatable-invoices-key)
      (datatables/overlay app-atom :open i.cfg/datatable-additional-key)
      (comms/send :admin.wholesale/client-order.invoice.item-list
        {:client-order/uuid client-order-uuid}))))

(defmethod comms/receive :admin.wholesale/client-order.invoice.item-list [app-atom {:keys [rows]}]
  (let [action-atom (cmn/action-cursor app-atom)]
    (datatables/overlay app-atom :close i.cfg/datatable-invoices-key)
    (datatables/overlay app-atom :close i.cfg/datatable-additional-key)
    (swap! action-atom assoc :client-order/invoice.item-list (yuc/index-by :invoice-line/id rows))))

(defmethod grid/action :admin.wholesale/client-order.invoice.override [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        invoice (cmn/curact process-atom :invoice)
        permission?
        (or
          (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
          (cmn/has-permission? app-atom "SiteAdmin:Teams:Finance"))]

    (cond
      permission?
      (do
        (toaster/open-overlay app-atom :admin.wholesale/client-order.overview {:text "Authorising override"})
        (comms/send :admin.wholesale/client-order.invoice.override
          {:invoice/uuid (:invoice/uuid invoice)
           :client-order/uuid (:client-order/uuid client-order)
           :override-reason (:override-reason config)}))

      :else
      (grid/dispatch-action app-atom :admin.wholesale/wholesale.unauthorised-warning
        {:permission "SiteAdmin:Teams:Finance"}))))

(defmethod comms/receive :admin.wholesale/client-order.invoice.override [app-atom {:keys [override?]}]
  (toaster/close-overlay app-atom :admin.wholesale/client-order.overview)
  (toaster/open-toast app-atom :warning "Enabling override" {:closetime 4000})
  (let [action-atom (cmn/action-cursor app-atom)]
    (when override?
      (swap! action-atom assoc :override-invoice true))))

(defmethod grid/action :admin.wholesale/client-order.invoice.email [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        invoice (cmn/curact process-atom :invoice)]
    (comms/send :admin.wholesale/client-order.invoice.email
      {:invoice-uuid (:invoice/uuid invoice)
       :order-uuid (:client-order/uuid client-order)
       :order-number (str "#SO-" (:client-order/ref-id client-order))
       :customer-name (:customer/name client-order)
       :emails (keys (:emails config))})))

(defmethod comms/receive :admin.wholesale/client-order.invoice.email [app-atom {:keys [msg]}]
  (toaster/open-toast app-atom :success msg {:closetime 3000}))